/**
 * 首页管理
 */
import api from '@/assets/libs/api.js'
import request from '@/assets/libs/request.js'

// ---------------------------------------------------- 多级字典 dtree

/**
 * 查询组织树列表
 * 多级字典；无入参；GET
 */
export const getOrgtreeList = (params) => {
	return request.get(api.dtree.orgtreeList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}


// ---------------------------------------------------- 日常护理 daily

/**
 * 修改日常护理记录
 * 必填id；创建者操作此接口 PUT
 */
export const updateDaily = (params) => {
	return request.put(api.daily.dailyUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 添加日常护理记录
 * 入参[Daily实体类]；创建者操作此接口 POST
 */
export const addDaily = (params) => {
	return request.post(api.daily.dailyAdd, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 根据ID删除日常护理记录
 * 入参id；DELETE
 */
export const deleteDaily = (_id) => {
	const relURL = api.daily.dailyDel.replace("{ids}", _id)
	return request.del(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '删除日常护理记录失败')
		});
}
/**
 * 查询日常护理记录列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getDailyList = (params) => {
	return request.get(api.daily.dailyGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}


// ---------------------------------------------------- 孕期胎儿数据与产检记录 pregnancy

/**
 * 修改孕期记录
 * 必填id；创建者操作此接口 PUT
 */
export const updatePregnancy = (params) => {
	return request.put(api.pregnancy.pregnancyUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 添加孕期记录
 * 入参[Pregnancy实体类]；创建者操作此接口 POST
 */
export const addPregnancy = (params) => {
	return request.post(api.pregnancy.pregnancyAdd, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询孕期记录列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getPregnancyList = (params) => {
	return request.get(api.pregnancy.pregnancyGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 根据ID删除孕期记录
 * 入参(必填ids)；DELETE
 */
export const deletePregnancy = (_id) => {
	const relURL = api.pregnancy.pregnancyDel.replace("{ids}", _id)
	return request.del(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '删除孕期记录失败')
		});
}


// ---------------------------------------------------- WHO 0-3岁生长曲线与评估 who

/**
 * 修改 WHO 生长曲线记录
 * 必填id；创建者操作此接口 PUT
 */
export const updateWho = (params) => {
	return request.put(api.who.whoUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 添加 WHO 生长曲线记录
 * 入参[Who实体类]；创建者操作此接口 POST
 */
export const addWho = (params) => {
	return request.post(api.who.whoAdd, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询 WHO 生长曲线记录列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getWhoList = (params) => {
	return request.get(api.who.whoGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}


/**
 * 删除 WHO 生长曲线记录
 * 入参(必填ids)；DELETE
 */
export const deleteWho = (_id) => {
	const relURL = api.who.whoDel.replace("{ids}", _id)
	return request.del(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '删除WHO生长曲线记录失败')
		});
}

// ---------------------------------------------------- 时光成长日记 note

/**
 * 修改 日记记录
 * 必填id；创建者操作此接口 PUT
 */
export const updateNote = (params) => {
	return request.put(api.note.noteUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 添加 日记记录
 * 入参[Note实体类]；创建者操作此接口 POST
 */
export const addNote = (params) => {
	return request.post(api.note.noteAdd, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询一条 日记记录详情
 * 入参id；GET
 */
export const getNoteById = (params) => {
	return request.get(api.note.noteGetByID, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询 日记记录列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getNoteList = (params) => {
	return request.get(api.note.noteGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}


/**
 * 删除 日记记录
 * 入参(必填ids)；DELETE
 */
export const deleteNote = (_id) => {
	const relURL = api.note.noteDel.replace("{ids}", _id)
	return request.del(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '删除日记记录失败')
		});
}




// ---------------------------------------------------- 辅食记录 food

/**
 * 修改 辅食记录
 * 必填id；创建者操作此接口 PUT
 */
export const updateFood = (params) => {
	return request.put(api.food.foodUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询 辅食记录列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getFoodList = (params) => {
	return request.get(api.food.foodGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}




// ---------------------------------------------------- 时光成长相册 photo

/**
 * 修改 相册素材
 * 必填id；创建者操作此接口 PUT
 */
export const updatePhoto = (params) => {
	return request.put(api.photo.photoUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 添加 相册素材
 * 入参[Photo实体类]；创建者操作此接口 POST
 */
export const addPhoto = (params) => {
	return request.post(api.photo.photoAdd, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询一条 相册素材详情
 * 入参id；GET
 */
export const getPhotoById = (params) => {
	return request.get(api.photo.photoGetByID, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询 相册素材列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getPhotoList = (params) => {
	return request.get(api.photo.photoGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 删除 相册素材
 * 入参(必填ids)；DELETE
 */
export const deletePhoto = (_id) => {
	const relURL = api.photo.photoDel.replace("{ids}", _id)
	return request.del(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '删除相册素材失败')
		});
}



// ---------------------------------------------------- 心情微语 comment

/**
 * 修改 心情微语
 * 必填id；创建者操作此接口 PUT
 */
export const updateComment = (params) => {
	return request.put(api.comment.commentUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 添加 心情微语
 * 入参[Comment实体类]；创建者操作此接口 POST
 */
export const addComment = (params) => {
	return request.post(api.comment.commentAdd, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 查询 心情微语列表
 * 入参(必填pageNum和pageSize)；GET
 */
export const getCommentList = (params) => {
	return request.get(api.comment.commentGetList, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}
/**
 * 删除 心情微语
 * 入参(必填ids)；DELETE
 */
export const deleteComment = (_id) => {
	const relURL = api.comment.commentDel.replace("{ids}", _id)
	return request.del(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '删除心情微语失败')
		});
}


// ---------------------------------------------------- 用户资料 userinfo

/**
 * 修改用户资料
 * 必填id；创建者操作此接口 PUT
 */
export const updateUserInfo = (params) => {
	return request.put(api.userinfo.userinfoUp, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}

/**
 * 获取用户资料
 * 入参id；GET
 */
export const getUserInfo = () => {
	const relURL = api.userinfo.userinfoGet
	return request.get(relURL)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error('请求失败' || err.msg)
		});
}


/**
 * 登录
 * 入参params；POST
 */
export const login = (params) => {
	return request.get(api.system.login, params)
		.then((res) => {
			return res
		})
		.catch((err) => {
			throw new Error(err.msg || '登录失败')
		});
}